import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Calendar } from 'primereact/calendar';
import { useNavigate } from 'react-router-dom';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import 'primeicons/primeicons.css';
import { localeCalendar, roundNumber } from '@utils';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllCompany } from '@/redux/slices/company/companySlices';
import { DeleteProducts } from '@/components/ModalProducts';
import { addLocale } from 'primereact/api';
import { selectUserData } from '@reduxSlices/user/userSlices';
import { Toast } from 'primereact/toast';
import './styles.scss';
import { fetchProducts } from '@/redux/slices/products/productsSlices';
import { formatedItems, formatedItemsExport } from './formatedItems';
import moment from 'moment';
import 'moment-timezone';

const Home = () => {
  const dispatch = useDispatch();
  const [datesPosting, setDatesPosting] = useState(null);
  const [selectCompany, setSelectCompany] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window?.innerWidth);
  const navigate = useNavigate();
  const { allCompany } = useSelector((state) => state.company);
  const arrayCompany = allCompany.map(({ name, _id }) => ({ name, code: _id }));
  const { role, company_id: userCompanyId } = useSelector(selectUserData) ?? {};
  const { items = [], status, error } = useSelector((state) => state.products) ?? {};
  const toast = useRef(null);
  addLocale('ua', localeCalendar);
  moment.tz.setDefault('Europe/Kiev');

  const toKievTime = (date) => {
    if (!date) return '';
    const newDate = moment(date).tz('Europe/Kiev');
    return newDate.toDate();
  };

  const arrItems = formatedItems(items, role);

  const commentBodyTemplate = (rowData) => {
    return (
      <>
        <Tooltip target='.truncate-text' mouseTrack mouseTrackTop={10} />
        <div className='truncate-text' data-pr-tooltip={rowData.comment} data-pr-position='top'>
          {rowData.comment}
        </div>
      </>
    );
  };

  const cols = [
    ...(role === 'admin'
      ? [
          {
            field: 'company_name',
            header: 'Підриємство',
            style: { maxWidth: '320px', minWidth: '250px' },
            sortable: true,
          },
        ]
      : []),
    { field: 'document_no', header: 'Документ №', style: { maxWidth: '250px', minWidth: '210px' } },
    {
      field: 'date_posting',
      header: 'Дата оприбуткування',
      style: { maxWidth: '300px', minWidth: '250px' },
      sortable: true,
    },
    { field: 'barcode', header: 'Бирки №', style: { maxWidth: '200px', minWidth: '150px' } },
    { field: 'supplier', header: 'Постачальник', style: { maxWidth: '280px', minWidth: '200px' } },
    {
      field: 'products',

      header: "Об'єм/продукція",
      style: { maxWidth: '400px', minWidth: '300px' },
    },
    { field: 'storage', header: 'Склад', style: { maxWidth: '300px', minWidth: '250px' } },
    { field: 'carrier', header: 'Перевізник', style: { maxWidth: '300px', minWidth: '200px' } },
    { field: 'length', header: 'Довжина', style: { maxWidth: '220px', minWidth: '200px' } },
    {
      field: 'comment',
      header: 'Коментар',
      body: commentBodyTemplate,
      style: { maxWidth: '300px', minWidth: '200px' },
    },
    ...(role === 'admin' ? [{ field: 'user', header: 'Користувач', style: { maxWidth: '250px' } }] : []),
  ];

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };

  const exportExcel = () => {
    const arrItems = formatedItemsExport(items, role);
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(arrItems);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      saveAsExcelFile(excelBuffer, 'products');
    });
  };

  const updateLoad = (companyId, datesPosting) => () => {
    dispatch(fetchProducts(productsGetParams(companyId, datesPosting)));
  };

  const productsGetParams = (companyId, datesPosting = []) => {
    const [startDatePosting, finishDatePosting] = datesPosting ?? [];

    return {
      ...(companyId ? { companyId } : {}),
      ...(startDatePosting && finishDatePosting
        ? {
            startDatePosting: moment(startDatePosting).format(),
            finishDatePosting: moment(finishDatePosting).format(),
          }
        : {}),
    };
  };

  const handleDateChange = (value) => {
    if (value === null) {
      return setDatesPosting(null);
    }
    const [start, end] = value ?? [];
    setDatesPosting([toKievTime(start), toKievTime(end)]);
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    const companyId = selectCompany?.code ? selectCompany?.code : null;

    dispatch(fetchProducts(productsGetParams(companyId ?? userCompanyId, datesPosting)));
  }, [selectCompany, datesPosting]);

  useEffect(() => {
    dispatch(fetchAllCompany());
  }, []);

  useEffect(() => {
    if (!selectCompany && role === 'admin') {
      setSelectCompany(arrayCompany[0]);
    }
  }, [arrayCompany]);

  useEffect(() => {
    if (status === 'failed') {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  }, [error, status]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const header = (
    <div className='flex header-home-table align-items-center justify-content-between gap-3'>
      <div className='flex align-items-center gap-3'>
        <Button
          type='button'
          icon='pi pi-file-excel'
          severity='success'
          rounded
          onClick={exportExcel}
          data-pr-tooltip='XLS'
        />
      </div>
      <div className='flex align-items-center gap-3'>
        <Calendar
          value={datesPosting}
          onChange={(e) => handleDateChange(e.value)}
          selectionMode='range'
          placeholder='Період оприбуткування'
          className='catalog__calendar w-full md:w-15rem'
          locale='ua'
          showIcon
          dateFormat='dd.mm.yy'
          maxDate={new Date()}
        />
        {role === 'admin' && allCompany?.length > 0 && (
          <Dropdown
            value={selectCompany}
            onChange={(e) => setSelectCompany(e.value)}
            className='catalog__select w-full md:w-20rem'
            options={arrayCompany}
            optionLabel='name'
            placeholder='Виберіть підриємство'
            emptyMessage='Поки що немає підриємств'
          />
        )}
        {['admin', 'manager'].includes(role) && allCompany?.length > 0 && (
          <Button icon='pi pi-plus' onClick={() => (window.location.href = '/receiving/new')} />
        )}
      </div>
    </div>
  );

  const BodyTemplate = (rowData) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className='card flex justify-content-start'>
        <Button
          type='button'
          icon='pi pi-pencil'
          rounded
          style={{ marginRight: '8px' }}
          onClick={() => navigate(`/receiving/${rowData?._id}`, { state: { isEditing: true } })}
        />

        {!rowData?.ifInventory && (
          <DeleteProducts
            visible={visible}
            open={() => {
              setVisible(true);
            }}
            hide={() => {
              setVisible(false);
            }}
            productData={rowData}
            updateLoad={updateLoad(selectCompany?.code ?? userCompanyId, datesPosting)}
          />
        )}
      </div>
    );
  };

  const sumTotal = () => {
    const capacity = items.reduce((acc, item) => acc + item.capacity, 0);
    return `${roundNumber(capacity)}м³`;
  };

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer="Об'єм:" colSpan={role === 'admin' ? 5 : 4} footerStyle={{ textAlign: 'right' }} />
        <Column footer={sumTotal} />
        <Column colSpan={7} footerStyle={{ textAlign: 'right' }} />
      </Row>
    </ColumnGroup>
  );

  return (
    <div className='page'>
      <h2 className='page__title'>Список приймання</h2>
      <DataTable
        value={arrItems}
        header={header}
        paginator
        showGridlines
        rows={50}
        responsiveLayout='scroll'
        scrollable
        // scrollHeight='400px'
        emptyMessage='Поки що немає даних'
        footerColumnGroup={footerGroup}
      >
        {cols.map(({ field, header, ...props }, index) => (
          <Column key={index} field={field} header={header} {...props} />
        ))}

        {role !== 'inspector' && (
          <Column
            header='Редагування'
            body={BodyTemplate}
            style={{ maxWidth: '160px', minWidth: '140px' }}
            frozen={windowWidth > 600}
            alignFrozen='right'
          ></Column>
        )}
      </DataTable>
      <Toast ref={toast} />
    </div>
  );
};

export default Home;
